import { bl_cms_notification_hdr_RowClass } from '../../dbschema/bl_cms_notification_hdr.model';
import { bl_cms_user_notification_link_RowClass } from '../../dbschema/bl_cms_user_notification_link.model';
import { bl_crm_membership_hdr_RowClass } from '../../dbschema/bl_crm_membership_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class UserNotificationLinkViewerContainerModel extends BaseContainerModel {
  bl_cms_user_notification_link: bl_cms_user_notification_link_RowClass = new bl_cms_user_notification_link_RowClass();
  bl_crm_membership_hdr: bl_crm_membership_hdr_RowClass = new bl_crm_membership_hdr_RowClass();
  bl_cms_notification_hdr: bl_cms_notification_hdr_RowClass = new bl_cms_notification_hdr_RowClass();
}
